import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoPipe } from '@jsverse/transloco';
import { TimeTrackingBarService } from './time-tracking-bar.service';
import { TimeTrackingDetailSheetComponent } from './time-tracking-detail-sheet.component';

@Component({
    selector: 'app-time-tracking-bar',
    standalone: true,
    imports: [
        TranslocoPipe,
        NgIf,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        MatDialogModule,
    ],
    templateUrl: './time-tracking-bar.component.html',
    styleUrls: ['./time-tracking-bar.component.scss'],
})
export class TimeTrackingBarComponent {
    constructor(
        public time: TimeTrackingBarService,
        private dialog: MatDialog
    ) {}

    openDetails(): void {
        if (this.dialog.getDialogById('time-tracking-details')) return;
        this.dialog.open(TimeTrackingDetailSheetComponent, {
            id: 'time-tracking-details',
            panelClass: 'mzeit-time-tracking-dialog',
            width: '720px',
            maxWidth: 'calc(100vw - 32px)',
            maxHeight: 'calc(100dvh - 32px)',
            ariaLabelledBy: 'time-tracking-details-title',
            autoFocus: 'first-tabbable',
        });
    }
}
